import React from "react";
// import Helmet from "../component/common/Helmet";
import {Helmet} from 'react-helmet'
import HeaderThree from "../component/header/HeaderThree";
import { useEffect, useState } from "react";

import {
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { useTranslation } from "react-i18next";

const TermsPage = () => {
const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/terms.html`)
      .then((res) => res.text())
      .then((data) => setHtmlContent(data));
  }, []);
  
  const { t, i18n } = useTranslation();
  const icon = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive.webp`;

  window.onload = function () {
    // Code runs after full page load
    console.log("Page fully loaded!");
    //const purpose = document.getElementById("purpose");
    //purpose.style.opacity = 0;
    document.querySelector(".header--fixed").classList.add("sticky");
  };

  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
        <title>Terms of use</title>
        <meta name="description" content="We accelerate the transition to eco-friendly consumption for the well-being of all." />
        <meta name="keywords" content= "ecoshift,shift,impact,transition,eco,friendly,consumption,eco-positive,sustainability,biodiversity,ecoresponsible" />
        <meta property="og:title" content="Terms of use" />
        <meta property="og:description" content="We accelerate the transition to eco-friendly consumption for the well-being of all." />
        <meta property="og:image" content={icon} />
        <meta property="og:url" content={process.env.PUBLIC_URL + "/"} />
        <meta name="twitter:card" content={icon} />
        <meta name="robots" content="index, follow"/>
        <link rel="canonical" href="https://ecoshift.eco/terms" />
      </Helmet>

      <HeaderThree homeLink="#" logo="symbol-dark" color="color-black" alwaysSticky="true"/>

      {/* Start Terms & Conditions Area  */}
      <Card id="terms" className="card_color--ugs ">
        <CardBody>
          <div className="slider-wrapper">
            <div id="whoweare" className="fix top-inset-main">
              <div className="service-area creative-service-wrapper pb--80 card_color--ugs ">
                <div className="container">
                  <br />
                  <br />
                  <br />
                  <div className="row">
                    <div className="col-lg-12 section-title mb_sm--0 d-flex-column-20">
                      {/* <p className="section-title text-color">
                        {t('Terms & Conditions')}
                      </p> */}
                      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      {/* End Terms & Conditions Area  */}
    </div>
  );
};

export default TermsPage;
